







import Vue from 'vue';
import { Logo } from '@descomplica/vue-components';

export default Vue.extend({
  name: 'ProuniHeader',
  components: { Logo },
});
